module.exports = __webpack_public_path__ + "img/Mask Group 12.546630fd.png";